/*  MUI  */
import { ExpandMore } from '@mui/icons-material';
import {
    Box,
    FormControl,
    FormLabel,
    Grid,
    MenuItem,
    Select
} from '@mui/material';
import { withTheme } from '@mui/styles';
import { DatePicker } from '@mui/x-date-pickers';

/*  Shared  */
import { Notify } from 'application/Shared/Helpers';

/* NPM */
import { endOfDay, startOfDay } from 'date-fns';
import dayjs from 'dayjs';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class TimePeriod extends Component {
    constructor(props) {
        super(props);

        const date = new Date();
        this.state = {
            custom: false,
            endDate: date,
            period: 'month',
            startDate: date.setMonth(date.getMonth() - 1)
        };
    }

    componentDidMount() {
        const { period } = this.props;
        this.handlePeriod(period);
    }

    handleCustom = (start, end) => {
        const { t, handleDate } = this.props;

        const startDate = startOfDay(new Date(start));
        const endDate = endOfDay(new Date(end));

        if (startDate > endDate) {
            Notify.error(t('Errors.start_greater_than_end'));
            return;
        }

        handleDate(startDate, endDate);
        this.setState({ endDate, startDate });
    };

    handlePeriod = async (period) => {
        const { handleDate } = this.props;
        let { custom, startDate, endDate } = this.state;

        const date = new Date();
        switch (period) {
            case 'all':
                date.setFullYear(date.getFullYear() - 2); // 2 years ago
                custom = false;
                break;
            case 'week':
                date.setDate(date.getDate() - 7);
                custom = false;
                break;
            case 'month':
                date.setMonth(date.getMonth() - 1);
                custom = false;
                break;
            case 'custom':
                custom = true;
                break;
            default:
                custom = false;
                break; // today
        }

        if (!custom) {
            startDate = startOfDay(date);
            endDate = endOfDay(new Date());

            handleDate(startDate, endDate);
        }

        this.setState({ custom, endDate, period, startDate });
    };

    renderCustom = () => {
        const { t } = this.props;
        const { startDate, endDate } = this.state;

        return (
            <Grid container spacing={3} marginRight="32px">
                <Grid item xs={6}>
                    <FormLabel>{t('Common.startDate')}:</FormLabel>
                    <DatePicker
                        value={dayjs(startDate)}
                        onChange={(e) => this.handleCustom(e, endDate)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormLabel>{t('Common.end_date')}:</FormLabel>
                    <DatePicker
                        value={dayjs(endDate)}
                        onChange={(e) => this.handleCustom(startDate, e)}
                    />
                </Grid>
            </Grid>
        );
    };

    renderSelect = () => {
        const { className, theme } = this.props;
        const { period } = this.state;

        return (
            <FormControl
                variant="standard"
                className={className}
                style={{ maxWidth: '500px', minWidth: '200px' }}
            >
                <Select
                    IconComponent={ExpandMore}
                    value={period}
                    onChange={(e) => this.handlePeriod(e.target.value)}
                    sx={{
                        backgroundColor:
                            theme.palette.background.timePeriodPicker,
                        padding: '8px'
                    }}
                >
                    <MenuItem value="all">All Time</MenuItem>
                    <MenuItem value="day">Today</MenuItem>
                    <MenuItem value="week">Past 7 Days</MenuItem>
                    <MenuItem value="month">Past 30 Days</MenuItem>
                    <MenuItem value="custom">Custom Time Period</MenuItem>
                </Select>
            </FormControl>
        );
    };

    render() {
        const { className } = this.props;
        const { custom } = this.state;

        return (
            <Box
                display="flex"
                className={className}
                style={{ maxWidth: '500px' }}
                justifyContent="flex-end"
            >
                {custom && this.renderCustom()}
                {this.renderSelect()}
            </Box>
        );
    }
}

export default withTranslation()(withTheme(TimePeriod));
